export const qualificationsData = [
  {
    id: 1,
    title: "Masters of Science",
    institute:
      "Mawlana Bhashani Science and Technology University, Santosh Tangail.",
    date: "2018 - 2019",
  },
  {
    id: 2,
    title: "Bachelor of Science",
    institute:
      "Mawlana Bhashani Science and Technology University, Santosh Tangail.",
    date: "2013 - 2017",
  },
  {
    id: 3,
    title: "Higher Secondary Certificate",
    institute: "Lions School and College, Saidpur.",
    date: "2011",
  },
  {
    id: 4,
    title: "Secondary School Certificate",
    institute: "Dandarhat High School, Chirirbandar.",
    date: "2009",
  },
];

export const experienceData = [
  {
    id: 1,
    title: "Executive Assistant Store Manager",
    institute: "Casa Bella Decor",
    date: "Nov-2022 - Present",
    description: "Working on the Cisco Webex Calling team",
  },
  {
    id: 2,
    title: "Product Listing Expert",
    institute: "The Village Country Store",
    date: "Jun-2019 - Present",
    description: "Worked on the Cisco Webex Calling team",
  },
  {
    id: 3,
    title: "E-commerce Management",
    institute: "Upwork ",
    date: "Jun-2019 - Present",
    description: "Worked on the Cisco Webex Calling team",
  },
  {
    id: 3,
    title: "E-commerce Development",
    institute: "Fiverr",
    date: "Sept-2020 - Present",
    description: "Worked on the Cisco Webex Calling team",
  },
];
